<template>
  <main>
    <PageIntro v-if="appLogin === false"
      :heading="'Register for a <span>My Wire</span> account'"
      :body="'<p>Enter your details below to create your  My Wire account. One time registration required with your email. Your  My Wire account will allow you seamless access to exclusive Warrington Wolves content.</p>'" />
    <PageIntro v-else
      :heading="'Register for a <span>My Wire</span> account'"
      :body="''" />
    <Registration />
    <FooterShout v-if="appLogin === false" :type="'signin'"/>
  </main>
</template>

<script>
  import Registration from '@/components/Registration'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      Registration,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
  }
</script>
